import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import { AuthService } from "../../../services/authService";
import PropTypes from "prop-types";

let authService = new AuthService();
class Password extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      password: "",
      password2: "",
      redirect: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }
  handleSubmit(event) {
    event.preventDefault();
    let self = this;
    const { email } = this.state;
    authService
      .recovery(email)
      .then(function(data) {
        if (!data.hasOwnProperty("error")) {
          self.context.getNotificationSystem().addNotification({
            title: "Email enviado",
            message: "Ingrese a su correo para cambiar la contraseña",
            level: "success"
          });
          self.setState({ redirect: true });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    const { email, redirect } = this.state;
    if (redirect) {
      return <Redirect to="/login" push={true} />;
    }
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Card className="mx-4">
                <CardBody className="p-4">
                  <form onSubmit={this.handleSubmit}>
                    <h1>Recuperacion de Contraseña</h1>
                    <p className="text-muted">Ingresa tu correo</p>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>@</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        placeholder="Email"
                        id="email"
                        value={email}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                    <Button color="success" block>
                      Recuperar Contraseña
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Password.contextTypes = {
  getNotificationSystem: PropTypes.func.isRequired
};

export default Password;
